import { render, staticRenderFns } from "./BaseTableParent.vue?vue&type=template&id=402f1e83&scoped=true&"
import script from "./BaseTableParent.vue?vue&type=script&lang=js&"
export * from "./BaseTableParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402f1e83",
  null
  
)

export default component.exports